/* eslint-disable no-use-before-define */
import React, { useContext } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import block from 'bem-cn'
import { useSignUpForm } from 'hooks'

import { ROUTE_PATHS } from 'router/routes'

import { selectLocaleDict } from 'features/locale/selectors'

import { useModalContext } from '@bcraft-frontend-lib/core'

import { ModalWrapper } from 'components/ModalWrapper'
import { Button, ButtonSizes, Form, FormInput } from 'components/UIKit'
import { Checkbox } from 'components/UIKit/Checkbox/Checkbox'

import './SignUpModal.scss'

type SignInModalProps = {
  path: string
}

const b = block('sign-up-modal')

export const SignUpModal: React.FC<SignInModalProps> = ({ path }) => {
  const { closeModal } = useModalContext()

  const history = useHistory()

  const locale = useSelector(selectLocaleDict, shallowEqual).auth
  const localeCommon = useSelector(selectLocaleDict, shallowEqual).common

  const onClose = closeModal(path)

  const { formik, isLoading } = useSignUpForm({
    onSuccessCallback: onClose,
  })

  const goToTerms = () => history.push(ROUTE_PATHS.TERMSANDCONDITIONS)

  return (
    <ModalWrapper hideLogo title={locale.signUp} className={b()} onClose={onClose}>
      <Form className={b('form')} formik={formik}>
        <FormInput
          name="username"
          placeholder={locale.username}
          caption={locale.username}
          autoComplete="new-username"
        />
        <FormInput
          type="email"
          name="email"
          placeholder={locale.email}
          caption={locale.email}
        />
        <FormInput
          type="email"
          name="repeatEmail"
          placeholder={locale.repeatEmail}
          caption={locale.repeatEmail}
        />
        <div className={b('password-buttons')}>
          <FormInput
            name="password"
            type="password"
            placeholder={locale.password}
            caption={locale.password}
            autoComplete="new-password"
            canBeHidden
          />
          <FormInput
            name="repeatPassword"
            type="password"
            placeholder={locale.repeatPassword}
            caption={locale.repeatPassword}
            canBeHidden
          />
        </div>
        <div className={b('checkbox-wrapper')}>
          <Checkbox
            onChange={(name, value) => formik.setFieldValue(name, value)}
            checked={formik.values.iAccept}
            name="iAccept"
          />
          <div className={b('adult-terms')}>
            <span>{locale.iAccept}</span>
            <span className={b('terms')} onClick={goToTerms}>
              {localeCommon.termsAndConditions}
            </span>
          </div>
        </div>
        <div className={b('checkbox-wrapper')}>
          <Checkbox
            onChange={(name, value) => formik.setFieldValue(name, value)}
            checked={formik.values.isAdult}
            name="isAdult"
          />
          <div className={b('adult-terms')}>
            <span>{locale.imAdult}</span>
          </div>
        </div>

        <Button
          text={locale.signUp}
          type="submit"
          disabled={isLoading || !formik.values.isAdult || !formik.values.iAccept}
          loading={isLoading}
          fullWidth
          size={ButtonSizes.LARGE}
        />
      </Form>
    </ModalWrapper>
  )
}
